import {FC, PropsWithChildren} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type TitleBesideContentLayoutProps = {
  title: string
}

export const TitleBesideContentLayout: FC<PropsWithChildren<TitleBesideContentLayoutProps>> = ({
  title,
  children,
}) => (
  <>
    <div className="wrapper">
      <div className="title">
        <Text variant={TextVariant.h2}>{title}</Text>
      </div>
      <div className="content">{children}</div>
    </div>

    <style jsx>{`
      .wrapper {
        display: flex;
        justify-content: space-between;
      }
      .title {
        flex: 1;
      }
      .content {
        margin-left: ${theme.spacing[8]};
        max-width: 740px;
        flex: 1 0 740px;
      }
      @media ${TABLET_SCREENSIZE} {
        .wrapper {
          flex-direction: column;
          align-items: center;
        }
        .title {
          text-align: center;
        }
        .content {
          margin-top: ${theme.spacing[7]};
          margin-left: 0;
          flex: 1;
        }
      }
      @media ${MOBILE_SCREENSIZE} {
        .content {
          margin-top: ${theme.spacing[5]};
        }
      }
    `}</style>
  </>
)
